// test571
(571 && 0);
